/**
 * Text length aligned with Python 3 `len(str)` — Unicode code points, not UTF-16 code units.
 * JS `String.length` counts UTF-16 units (emoji often = 2); Python len counts one per code point.
 */
export function textLength(value) {
  if (value == null || value === "") return 0;
  return [...String(value)].length;
}

/** Truncate to at most `maxLen` code points (Python len). */
export function truncateText(value, maxLen) {
  const s = String(value ?? "");
  const chars = [...s];
  if (chars.length <= maxLen) return s;
  return chars.slice(0, maxLen).join("");
}
